
<nav class="navbar navbar-expand-lg navbar-dark ">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarColor01"
        aria-controls="navbarColor01" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div class="navbar" id="navbarColor01">
        <ul class="navbar-nav mr-auto">
           
            <li class="nav-item">
                <button (click)="Consulta()" class="btn btn-primary opcion">CONSULTA</button>
            </li>
            <li class="nav-item">
                <button (click)="selectReporte('tablaSimbolos')" type="button" class="btn btn-primary opcion">REPORTES</button>
            </li>
            <!-- <li class="nav-item">
                <button (click)="selectReporte('tablaErrores')" type="button" class="btn btn-primary opcion">Tabla de Errores</button>
            </li> -->
        </ul>
    </div>
</nav>

<div class="card-body">
    
<div style="width: 850px; height: 400px; margin: auto;" class="monacoCointeiner">
    <div class="card text-white tarjeta">
        XPATH
                                 
    <ngx-monaco-editor [options]="editorOptions"
    [(ngModel)]="XPATH[indiceEditorActual]" (init)="editorInit($event)" aria-readonly="true">
</ngx-monaco-editor>
</div>
</div>
</div>
<div class="container-fluid">
    <div class="row justify-content-center contenedor">
        <div class="col-md-12">
            <br>
            <div class="row">
                <div class="col-md-6">
                   
                    <div class="card text-white tarjeta">
                    
                        <div class="card-header">
                            <p class="lab">Editor</p>
                            <div *ngFor="let texto of textoEditores; let i = index; "  (click)="indiceEditorActual = i" type="button" class="btn btn-primary tab verde">
                                <div class="equis">TAB_{{i}}</div>
                                <div (click)="imprimir()" type="button" class="btn btn-primary equisa verde" (click)="eliminarEditor(i)">x</div>
                            </div>
                            <button (click)="agregarTab()" type="button" class="btn btn-primary mas verde">+</button>
                            <!-- Button trigger modal -->
                            <button (click)="imprimir()" type="button" class="btn btn-primary op mas verde" data-toggle="modal" data-target="#exampleModal">
                                Cargar Archivo
                            </button>
                            <button (click)="guardar()" type="button" class="btn btn-primary op mas verde">Guardar</button>
                         
                   
                        </div>

                    
                        <div class="card-body">
                            <div style="width: auto; height: 450px;" class="monacoCointeiner">
                                <ngx-monaco-editor [options]="editorOptions"
                                    [(ngModel)]="textoEditores[indiceEditorActual]" (init)="editorInit($event)"></ngx-monaco-editor>
                            </div>

                          
                        </div>
                        <br>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="card text-white tarjeta">
                        <div class="card-header">
                            Consola
                            <button (click)="compilar()" type="button" class="btn btn-primary mas verde">Compilador Ascendente</button>
                          
                            <button (click)="console=''" type="button" class="btn btn-primary mas op verde">Limpiar</button>
                            <button (click)="compilarD()" type="button" class="btn btn-primary mas verde">Compilador Descendente</button>
                            
                        </div>
                       
                        <div class="card-body">
                            <div style="width: auto; height: 458px;" class="monacoCointeiner">
                                <ngx-monaco-editor [options]="consoleOptions"
                                    [(ngModel)]="console" (init)="editorInit($event)" aria-readonly="true">
                                </ngx-monaco-editor>
                         
                            </div>

                        </div>
                        <br>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="app"  style="width: auto; height: 1000px;" >
        <img [src]="astBase64" class="zoom">


    </div>
    <div *ngIf="reporteSelccionado === 'tablaSimbolos'">

        
        <div class="row justify-content-center tabla">
            <div class="col-md-8 tab">
                <ul class="nav nav-tabs justify-content-center">
                    <li class="nav-item active">
                        <a class="nav-link active" data-toggle="tab" href="#simbolos">Tabla de Símbolos</a>
                    </li>
                </ul>
               
                <div id="myTabContent" class="tab-content">
                    <div class="tab-pane fade in active show" id="simbolos">
                        <div class="col-md-12">
                            <br>
                            <div style="width: auto; height: auto;">
                                <table class="table table-hover table-hover">
                                    <thead>
                                        <tr>
                                            <td>NOMBRE</td>
                                            <td>TIPO_SIMBOLO</td>
                                            <td>AMBITO</td>
                                            <td>COLUMNA</td>
                                            <td>FILA</td>
                                            <td>VALOR</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let fila of tablaSimbolos">
                                            <td>{{fila.nombre}}</td>
                                            <td>{{fila.tipo}}</td>
                                            <td>-{{fila.listaAmbito.join("-")}}-</td>
                                            <td>{{fila.columna}}</td>
                                            <td>{{fila.fila}}</td>
                                            <td>--{{fila.valor}}--</td>
                                        </tr>
                                    
                                    </tbody>
                                </table>
                            </div>
        
                            <div style="width: auto; height: auto;">
                                <ul class="nav nav-tabs justify-content-center">
                                    <li class="nav-item active">
                                        <a class="nav-link active" data-toggle="tab" href="#simbolos">ReporteGramaticaL</a>
                                    </li>
                                </ul>
                                <table class="table table-hover table-hover">
                                    <thead>
                                        <tr>
                                            <td>PRODUCCION</td>
                                            <td>regla_semantica</td>
                                         
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let fila of ReporteGramatica">
                                            <td>{{fila.produccion}}</td>
                                            <td>{{fila.regla_semantica}}</td>
                                        </tr>
                                    
                                    </tbody>
                                </table>
                            </div>
                            <br>
                        </div>
                    </div>
                    <div style="width: auto; height: auto;">
                        <ul class="nav nav-tabs justify-content-center">
                            <li class="nav-item active">
                                <a class="nav-link active" data-toggle="tab" href="#simbolos">ERRORES</a>
                            </li>
                        </ul>

                     
                        <table class="table table-hover table-hover">
                            <thead>
                                <tr> 
                                    <td>SIMBOLO</td>
                                    <td>TIPO</td>
                                    <td>Linea</td>
                                    <td>Columna</td>
                                    <td>Entorno</td>
                                    
                                 
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let fila of Error">
                                    <td>{{fila.simbolo}}</td>
                                    <td>{{fila.tipo}}</td>
                                    <td>{{fila.linea}}</td>
                                    <td>{{fila.columna}}</td>
                                    <td>{{fila.entorno}}</td>
                                </tr>
                            
                            </tbody>
                        </table>
                    </div>
                    <div class="tab-pane fade" id="errores">
                        <div class="col-md-12">
                            <br>
                            <div style="width: auto; height: auto;">
                                <table class="table table-danger table-hover">
                                    <thead>
                                        <tr>
                                            <td>hola</td>
                                            <td>mundo</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>2</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <br>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
  
    <div  id ="app" *ngIf="reporteSelccionado === 'arbolAst'">
        <img [src]="astBase64" class="zoom">
        alv
    </div>
 
   
</div>
<script>
  export  function prueba(){
        console.log(this.astBase64)
 
    }
   


</script>
<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Cargar archivo de entrada</h5>
            </div>
            <div class="modal-body">
                <div class="input-group">
                    <div class="custom-file">
                        <input type="file" class="custom-file-input" id="inputGroupFile01"
                                aria-describedby="inputGroupFileAddon01" (change)="seleccionarArchivo($event)">
                        <label class="custom-file-label" for="inputGroupFile01" id="choosedFile"
                                accept=".xml">{{nombreArchivo}}</label>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="cargarArchivo()" data-dismiss="modal">Continuar</button>
            </div>
        </div>
    </div>
</div>
<!-- fin de boostrap -->
